// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: var(--ca-text-primary, #172033);
}

.file-import-dialog {
  width: min(100%, 68rem);
  max-height: 90vh;
  overflow: auto;
  padding: 1.5rem;
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid var(--ca-border, #dfe4ec);
}

.title-icon {
  display: grid;
  flex: 0 0 2.8rem;
  width: 2.8rem;
  height: 2.8rem;
  place-items: center;
  border-radius: 12px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.35rem;
}

.header-copy {
  flex: 1;
  min-width: 0;
}

.header-copy h2 {
  margin: 0.1rem 0 0.3rem;
  font-size: 1.25rem;
  font-weight: 700;
}

.header-copy p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.icon-button {
  display: grid;
  width: 2.25rem;
  height: 2.25rem;
  place-items: center;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: var(--ca-text-secondary, #4b5870);
}

.icon-button:hover:not(:disabled) {
  background: var(--ca-bg-secondary, #f7f9fc);
  border-color: var(--ca-border, #dfe4ec);
}

.source-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding: 0.9rem 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.85rem;
}

.source-meta span {
  display: flex;
  align-items: baseline;
  gap: 0.45rem;
}

.source-meta strong {
  color: var(--ca-text-primary, #172033);
  font-weight: 650;
}

.drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.75rem 1rem;
  border: 1.5px dashed var(--ca-border-dark, #c5cedc);
  border-radius: 14px;
  background: var(--ca-bg, #f8faff);
  text-align: center;
}

.drop-zone.has-file {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
}

.drop-icon {
  color: var(--ca-primary, #0e2e80);
  font-size: 2.3rem;
}

.drop-zone h3 {
  margin: 0.5rem 0 0.35rem;
  font-size: 1.05rem;
  font-weight: 650;
}

.drop-zone p {
  margin: 0 0 0.8rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.88rem;
}

.selected-filename {
  max-width: 100%;
  overflow-wrap: anywhere;
  font-weight: 600;
}

.drop-zone input[type=file] {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.browse-button {
  display: inline-flex;
  min-height: 2.4rem;
  align-items: center;
  padding: 0.55rem 0.9rem;
  border-radius: 8px;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  cursor: pointer;
  font-size: 0.88rem;
  font-weight: 650;
}

.browse-button:hover {
  background: var(--ca-primary-dark, #0d2863);
}

.drop-zone small {
  margin-top: 0.75rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
}

.feedback {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  margin-top: 0.9rem;
  padding: 0.75rem 0.85rem;
  border: 1px solid;
  border-radius: 8px;
  font-size: 0.88rem;
}

.feedback.error {
  border-color: var(--ca-danger, #b42318);
  background: var(--ca-danger-bg, #fff2f0);
  color: var(--ca-danger, #b42318);
}

.feedback.success {
  border-color: var(--ca-success, #17803d);
  background: var(--ca-success-bg, #edfff3);
  color: var(--ca-success, #176b35);
}

.progress-message {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.9rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.88rem;
}

.spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.imported-assets {
  margin-top: 1.35rem;
}

.results-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.results-heading h3 {
  margin: 0 0 0.25rem;
  font-size: 1rem;
  font-weight: 700;
}

.results-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.result-count {
  display: grid;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.45rem;
  place-items: center;
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.8rem;
  font-weight: 700;
}

.table-wrap {
  max-height: 19rem;
  overflow: auto;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 8px;
}

.assets-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.assets-table th {
  position: sticky;
  top: 0;
  padding: 0.7rem;
  background: var(--ca-bg-secondary, #f7f9fc);
  color: var(--ca-text-secondary, #4b5870);
  text-align: left;
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.04em;
}

.assets-table td {
  max-width: 16rem;
  padding: 0.7rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
  overflow-wrap: anywhere;
  vertical-align: top;
}

.assets-table td strong, .assets-table td small {
  display: block;
}

.assets-table td small {
  margin-top: 0.2rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
}

.empty-results {
  display: flex;
  min-height: 5rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 8px;
  color: var(--ca-text-secondary, #4b5870);
}

.empty-results p {
  margin: 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.65rem;
  padding-top: 1.25rem;
  margin-top: 1.1rem;
  border-top: 1px solid var(--ca-border, #dfe4ec);
}

.btn-primary, .btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.5rem;
  padding: 0.6rem 0.9rem;
  border-radius: 8px;
  font-size: 0.88rem;
  font-weight: 650;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.btn-primary:hover:not(:disabled) {
  background: var(--ca-primary-dark, #0d2863);
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}

.btn-primary:disabled, .btn-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 640px) {
  .file-import-dialog {
    padding: 1rem;
  }
  .source-meta {
    flex-direction: column;
    gap: 0.5rem;
  }
  .dialog-footer {
    flex-direction: column-reverse;
  }
  .dialog-footer button {
    width: 100%;
  }
}
/* Additional states for source details and file selection. */
.source-meta code {
  font-size: 0.75rem;
}

.browse-button.disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.remove-file-button {
  margin-top: 0.65rem;
  border: 0;
  background: transparent;
  color: var(--ca-danger, #b42318);
  font-size: 0.82rem;
  font-weight: 600;
}

.remove-file-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.drop-zone.is-disabled {
  opacity: 0.75;
}

.feedback {
  line-height: 1.45;
}

.assets-table th {
  white-space: nowrap;
}

.assets-table td {
  max-width: 18rem;
}

@media (max-width: 760px) {
  .assets-table {
    min-width: 48rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/data-asset-capture/data-assets-capture-for-file-asset-source/data-assets-capture-for-file-asset-source.component.scss"],"names":[],"mappings":"AAAA;EAAQ,cAAA;EAAgB,sCAAA;AAGxB;;AAFA;EAAsB,uBAAA;EAAyB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;AASjF;;AARA;EAAiB,aAAA;EAAe,uBAAA;EAAyB,WAAA;EAAY,sBAAA;EAAwB,kDAAA;AAgB7F;;AAfA;EAAc,aAAA;EAAe,gBAAA;EAAkB,aAAA;EAAe,cAAA;EAAgB,mBAAA;EAAqB,mBAAA;EAAqB,6CAAA;EAA+C,iCAAA;EAAmC,kBAAA;AA2B1M;;AA1BA;EAAe,OAAA;EAAS,YAAA;AA+BxB;;AA9BA;EAAkB,uBAAA;EAAuB,kBAAA;EAAoB,gBAAA;AAoC7D;;AAnCA;EAAiB,SAAA;EAAW,wCAAA;EAA0C,iBAAA;AAyCtE;;AAxCA;EAAe,aAAA;EAAe,cAAA;EAAgB,eAAA;EAAiB,mBAAA;EAAqB,6BAAA;EAA+B,kBAAA;EAAoB,uBAAA;EAAyB,wCAAA;AAmDhK;;AAlDA;EAAoC,2CAAA;EAA6C,uCAAA;AAuDjF;;AAtDA;EAAe,aAAA;EAAe,eAAA;EAAiB,WAAA;EAAa,iBAAA;EAAkB,wCAAA;EAA0C,kBAAA;AA+DxH;;AA9DA;EAAoB,aAAA;EAAe,qBAAA;EAAuB,YAAA;AAoE1D;;AAnEA;EAAsB,sCAAA;EAAwC,gBAAA;AAwE9D;;AAvEA;EAAa,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAAqB,qBAAA;EAAuB,mDAAA;EAAqD,mBAAA;EAAqB,iCAAA;EAAmC,kBAAA;AAkF7M;;AAjFA;EAAsB,wCAAA;EAA0C,6CAAA;AAsFhE;;AArFA;EAAa,iCAAA;EAAmC,iBAAA;AA0FhD;;AAzFA;EAAgB,wBAAA;EAAwB,kBAAA;EAAoB,gBAAA;AA+F5D;;AA9FA;EAAe,kBAAA;EAAmB,wCAAA;EAA0C,kBAAA;AAoG5E;;AAnGA;EAAqB,eAAA;EAAiB,uBAAA;EAAyB,gBAAA;AAyG/D;;AAxGA;EAAgC,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,UAAA;EAAY,oBAAA;AAgHzF;;AA/GA;EAAiB,oBAAA;EAAsB,kBAAA;EAAoB,mBAAA;EAAqB,uBAAA;EAAuB,kBAAA;EAAoB,sCAAA;EAAwC,WAAA;EAAa,eAAA;EAAiB,kBAAA;EAAmB,gBAAA;AA4HpN;;AA3HA;EAAuB,2CAAA;AA+HvB;;AA9HA;EAAmB,mBAAA;EAAoB,oCAAA;EAAsC,kBAAA;AAoI7E;;AAnIA;EAAY,aAAA;EAAe,WAAA;EAAY,uBAAA;EAAyB,kBAAA;EAAmB,wBAAA;EAAwB,iBAAA;EAAmB,kBAAA;EAAoB,kBAAA;AA8IlJ;;AA7IA;EAAkB,uCAAA;EAAyC,wCAAA;EAA0C,gCAAA;AAmJrG;;AAlJA;EAAoB,wCAAA;EAA0C,yCAAA;EAA2C,iCAAA;AAwJzG;;AAvJA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAY,kBAAA;EAAmB,wCAAA;EAA0C,kBAAA;AAgKjI;;AA/JA;EAAW,WAAA;EAAa,YAAA;EAAc,2CAAA;EAA6C,4CAAA;EAA8C,kBAAA;EAAoB,oCAAA;AAwKrJ;;AAvKA;EAAmB,mBAAA;AA2KnB;;AA1KA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,sBAAA;AAkLlG;;AAjLA;EAAsB,mBAAA;EAAoB,eAAA;EAAiB,gBAAA;AAuL3D;;AAtLA;EAAqB,SAAA;EAAW,wCAAA;EAA0C,kBAAA;AA4L1E;;AA3LA;EAAgB,aAAA;EAAe,eAAA;EAAiB,YAAA;EAAc,kBAAA;EAAmB,mBAAA;EAAqB,oBAAA;EAAsB,6CAAA;EAA+C,iCAAA;EAAmC,iBAAA;EAAkB,gBAAA;AAwMhO;;AAvMA;EAAc,iBAAA;EAAmB,cAAA;EAAgB,2CAAA;EAA6C,kBAAA;AA8M9F;;AA7MA;EAAgB,WAAA;EAAa,yBAAA;EAA2B,kBAAA;AAmNxD;;AAlNA;EAAmB,gBAAA;EAAkB,MAAA;EAAQ,eAAA;EAAgB,2CAAA;EAA6C,wCAAA;EAA0C,gBAAA;EAAkB,yBAAA;EAA2B,iBAAA;EAAkB,sBAAA;AA8NnN;;AA7NA;EAAmB,gBAAA;EAAkB,eAAA;EAAgB,qDAAA;EAAuD,uBAAA;EAAyB,mBAAA;AAqOrI;;AApOA;EAAkD,cAAA;AAwOlD;;AAvOA;EAAyB,kBAAA;EAAmB,oCAAA;EAAsC,kBAAA;AA6OlF;;AA5OA;EAAiB,aAAA;EAAe,gBAAA;EAAkB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAY,2CAAA;EAA6C,kBAAA;EAAoB,wCAAA;AAuP7K;;AAtPA;EAAmB,SAAA;AA0PnB;;AAzPA;EAAiB,aAAA;EAAe,yBAAA;EAA2B,YAAA;EAAa,oBAAA;EAAsB,kBAAA;EAAoB,+CAAA;AAkQlH;;AAjQA;EAA+B,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,YAAA;EAAa,kBAAA;EAAoB,sBAAA;EAAsB,kBAAA;EAAoB,kBAAA;EAAmB,gBAAA;AA6QjM;;AA5QA;EAAe,4CAAA;EAA8C,sCAAA;EAAwC,WAAA;AAkRrG;;AAjRA;EAAoC,2CAAA;AAqRpC;;AApRA;EAAiB,2CAAA;EAA6C,mCAAA;EAAqC,iCAAA;AA0RnG;;AAzRA;EAAiD,mBAAA;EAAqB,aAAA;AA8RtE;;AA7RA;EAAkB;IAAK,yBAAA;EAkSrB;AACF;AAlSA;EAA4B;IAAsB,aAAA;EAsShD;EAtSiE;IAAe,sBAAA;IAAwB,WAAA;EA0SxG;EA1SsH;IAAiB,8BAAA;EA6SvI;EA7SyK;IAAwB,WAAA;EAgTjM;AACF;AA/SA,6DAAA;AACA;EAAoB,kBAAA;AAkTpB;;AAjTA;EAA0B,aAAA;EAAc,mBAAA;AAsTxC;;AArTA;EACE,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AAwTF;;AAtTA;EAA+B,aAAA;EAAc,mBAAA;AA2T7C;;AA1TA;EAAyB,aAAA;AA8TzB;;AA7TA;EAAY,iBAAA;AAiUZ;;AAhUA;EAAmB,mBAAA;AAoUnB;;AAnUA;EAAmB,gBAAA;AAuUnB;;AArUA;EACE;IAAgB,gBAAA;EAyUhB;AACF","sourcesContent":[":host { display: block; color: var(--ca-text-primary, #172033); }\n.file-import-dialog { width: min(100%, 68rem); max-height: 90vh; overflow: auto; padding: 1.5rem; }\n.dialog-header { display: flex; align-items: flex-start; gap: .9rem; padding-bottom: 1.2rem; border-bottom: 1px solid var(--ca-border, #dfe4ec); }\n.title-icon { display: grid; flex: 0 0 2.8rem; width: 2.8rem; height: 2.8rem; place-items: center; border-radius: 12px; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: 1.35rem; }\n.header-copy { flex: 1; min-width: 0; }\n.header-copy h2 { margin: .1rem 0 .3rem; font-size: 1.25rem; font-weight: 700; }\n.header-copy p { margin: 0; color: var(--ca-text-secondary, #4b5870); font-size: .9rem; }\n.icon-button { display: grid; width: 2.25rem; height: 2.25rem; place-items: center; border: 1px solid transparent; border-radius: 8px; background: transparent; color: var(--ca-text-secondary, #4b5870); }\n.icon-button:hover:not(:disabled) { background: var(--ca-bg-secondary, #f7f9fc); border-color: var(--ca-border, #dfe4ec); }\n.source-meta { display: flex; flex-wrap: wrap; gap: 1.5rem; padding: .9rem 0; color: var(--ca-text-secondary, #4b5870); font-size: .85rem; }\n.source-meta span { display: flex; align-items: baseline; gap: .45rem; }\n.source-meta strong { color: var(--ca-text-primary, #172033); font-weight: 650; }\n.drop-zone { display: flex; flex-direction: column; align-items: center; padding: 1.75rem 1rem; border: 1.5px dashed var(--ca-border-dark, #c5cedc); border-radius: 14px; background: var(--ca-bg, #f8faff); text-align: center; }\n.drop-zone.has-file { border-color: var(--ca-primary, #0e2e80); background: var(--ca-surface-active, #eef3ff); }\n.drop-icon { color: var(--ca-primary, #0e2e80); font-size: 2.3rem; }\n.drop-zone h3 { margin: .5rem 0 .35rem; font-size: 1.05rem; font-weight: 650; }\n.drop-zone p { margin: 0 0 .8rem; color: var(--ca-text-secondary, #4b5870); font-size: .88rem; }\n.selected-filename { max-width: 100%; overflow-wrap: anywhere; font-weight: 600; }\n.drop-zone input[type='file'] { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; }\n.browse-button { display: inline-flex; min-height: 2.4rem; align-items: center; padding: .55rem .9rem; border-radius: 8px; background: var(--ca-primary, #0e2e80); color: #fff; cursor: pointer; font-size: .88rem; font-weight: 650; }\n.browse-button:hover { background: var(--ca-primary-dark, #0d2863); }\n.drop-zone small { margin-top: .75rem; color: var(--ca-text-muted, #8c96a8); font-size: .75rem; }\n.feedback { display: flex; gap: .5rem; align-items: flex-start; margin-top: .9rem; padding: .75rem .85rem; border: 1px solid; border-radius: 8px; font-size: .88rem; }\n.feedback.error { border-color: var(--ca-danger, #b42318); background: var(--ca-danger-bg, #fff2f0); color: var(--ca-danger, #b42318); }\n.feedback.success { border-color: var(--ca-success, #17803d); background: var(--ca-success-bg, #edfff3); color: var(--ca-success, #176b35); }\n.progress-message { display: flex; align-items: center; gap: .6rem; margin-top: .9rem; color: var(--ca-text-secondary, #4b5870); font-size: .88rem; }\n.spinner { width: 1rem; height: 1rem; border: 2px solid var(--ca-border, #dfe4ec); border-top-color: var(--ca-primary, #0e2e80); border-radius: 50%; animation: spin .8s linear infinite; }\n.imported-assets { margin-top: 1.35rem; }\n.results-heading { display: flex; align-items: center; justify-content: space-between; gap: 1rem; margin-bottom: .75rem; }\n.results-heading h3 { margin: 0 0 .25rem; font-size: 1rem; font-weight: 700; }\n.results-heading p { margin: 0; color: var(--ca-text-secondary, #4b5870); font-size: .82rem; }\n.result-count { display: grid; min-width: 2rem; height: 2rem; padding: 0 .45rem; place-items: center; border-radius: 999px; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: .8rem; font-weight: 700; }\n.table-wrap { max-height: 19rem; overflow: auto; border: 1px solid var(--ca-border, #dfe4ec); border-radius: 8px; }\n.assets-table { width: 100%; border-collapse: collapse; font-size: .82rem; }\n.assets-table th { position: sticky; top: 0; padding: .7rem; background: var(--ca-bg-secondary, #f7f9fc); color: var(--ca-text-secondary, #4b5870); text-align: left; text-transform: uppercase; font-size: .7rem; letter-spacing: .04em; }\n.assets-table td { max-width: 16rem; padding: .7rem; border-top: 1px solid var(--ca-border-light, #e9edf3); overflow-wrap: anywhere; vertical-align: top; }\n.assets-table td strong, .assets-table td small { display: block; }\n.assets-table td small { margin-top: .2rem; color: var(--ca-text-muted, #8c96a8); font-size: .72rem; }\n.empty-results { display: flex; min-height: 5rem; align-items: center; justify-content: center; gap: .5rem; border: 1px solid var(--ca-border, #dfe4ec); border-radius: 8px; color: var(--ca-text-secondary, #4b5870); }\n.empty-results p { margin: 0; }\n.dialog-footer { display: flex; justify-content: flex-end; gap: .65rem; padding-top: 1.25rem; margin-top: 1.1rem; border-top: 1px solid var(--ca-border, #dfe4ec); }\n.btn-primary, .btn-secondary { display: inline-flex; align-items: center; justify-content: center; gap: .45rem; min-height: 2.5rem; padding: .6rem .9rem; border-radius: 8px; font-size: .88rem; font-weight: 650; }\n.btn-primary { border: 1px solid var(--ca-primary, #0e2e80); background: var(--ca-primary, #0e2e80); color: #fff; }\n.btn-primary:hover:not(:disabled) { background: var(--ca-primary-dark, #0d2863); }\n.btn-secondary { border: 1px solid var(--ca-border, #dfe4ec); background: var(--ca-surface, #fff); color: var(--ca-primary, #0e2e80); }\n.btn-primary:disabled, .btn-secondary:disabled { cursor: not-allowed; opacity: .55; }\n@keyframes spin { to { transform: rotate(360deg); } }\n@media (max-width: 640px) { .file-import-dialog { padding: 1rem; } .source-meta { flex-direction: column; gap: .5rem; } .dialog-footer { flex-direction: column-reverse; } .dialog-footer button { width: 100%; } }\n\n/* Additional states for source details and file selection. */\n.source-meta code { font-size: .75rem; }\n.browse-button.disabled { opacity: .55; cursor: not-allowed; }\n.remove-file-button {\n  margin-top: .65rem;\n  border: 0;\n  background: transparent;\n  color: var(--ca-danger, #b42318);\n  font-size: .82rem;\n  font-weight: 600;\n}\n.remove-file-button:disabled { opacity: .55; cursor: not-allowed; }\n.drop-zone.is-disabled { opacity: .75; }\n.feedback { line-height: 1.45; }\n.assets-table th { white-space: nowrap; }\n.assets-table td { max-width: 18rem; }\n\n@media (max-width: 760px) {\n  .assets-table { min-width: 48rem; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
